import { render } from "./ReportWaste.vue?vue&type=template&id=1dce4f09&scoped=true"
import script from "./ReportWaste.vue?vue&type=script&lang=js"
export * from "./ReportWaste.vue?vue&type=script&lang=js"

import "./ReportWaste.vue?vue&type=style&index=0&id=1dce4f09&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1dce4f09"]])

export default __exports__